import FormSection from './FormSection'
import { translations } from '../../data/translations'
import './FormSection.css'

const ContactSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.contact || translations.de.contact

  return (
    <FormSection title={t.title}>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="vereinsname" className="form-group__label">
            {t.vereinsname}
          </label>
          <input
            type="text"
            id="vereinsname"
            name="vereinsname"
            className="form-group__input"
            placeholder={t.vereinsnamePlaceholder}
            value={formData.vereinsname || ''}
            onChange={(e) => updateFormData('vereinsname', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="gruendungsjahr" className="form-group__label">
            {t.gruendungsjahr}
          </label>
          <input
            type="text"
            id="gruendungsjahr"
            name="gruendungsjahr"
            className="form-group__input"
            value={formData.gruendungsjahr || ''}
            onChange={(e) => updateFormData('gruendungsjahr', e.target.value)}
          />
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="ansprechpartner" className="form-group__label">
            {t.ansprechpartner}
          </label>
          <input
            type="text"
            id="ansprechpartner"
            name="ansprechpartner"
            className="form-group__input"
            placeholder={t.ansprechpartnerPlaceholder}
            value={formData.ansprechpartner || ''}
            onChange={(e) => updateFormData('ansprechpartner', e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="position" className="form-group__label">
            {t.position}
          </label>
          <input
            type="text"
            id="position"
            name="position"
            className="form-group__input"
            value={formData.position || ''}
            onChange={(e) => updateFormData('position', e.target.value)}
          />
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="email" className="form-group__label">
            {t.email}
          </label>
          <input
            type="email"
            id="email"
            name="email"
            className="form-group__input"
            value={formData.email || ''}
            onChange={(e) => updateFormData('email', e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="telefon" className="form-group__label">
            {t.telefon}
          </label>
          <input
            type="tel"
            id="telefon"
            name="telefon"
            className="form-group__input"
            value={formData.telefon || ''}
            onChange={(e) => updateFormData('telefon', e.target.value)}
          />
        </div>
      </div>

      <div className="form-grid form-grid--full">
        <div className="form-group">
          <label htmlFor="webseite_aktuell" className="form-group__label">
            {t.webseite_aktuell}
          </label>
          <input
            type="url"
            id="webseite_aktuell"
            name="webseite_aktuell"
            className="form-group__input"
            value={formData.webseite_aktuell || ''}
            onChange={(e) => updateFormData('webseite_aktuell', e.target.value)}
          />
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="standort" className="form-group__label">
            {t.standort}
          </label>
          <input
            type="text"
            id="standort"
            name="standort"
            className="form-group__input"
            value={formData.standort || ''}
            onChange={(e) => updateFormData('standort', e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="adresse" className="form-group__label">
            {t.adresse}
          </label>
          <input
            type="text"
            id="adresse"
            name="adresse"
            className="form-group__input"
            value={formData.adresse || ''}
            onChange={(e) => updateFormData('adresse', e.target.value)}
          />
        </div>
      </div>
    </FormSection>
  )
}

export default ContactSection
